import { Box, Typography } from "@material-ui/core";

export enum ModelTagEnum {
	VALUE_BASED = "Value based",
	FINANCIAL_BASED = "Financial based",
}

export const modelTagColor = {
	[ModelTagEnum.VALUE_BASED]: { color: "#0B5A65", backgroundColor: "#D1E0E2" },
	[ModelTagEnum.FINANCIAL_BASED]: { color: "#7C4595", backgroundColor: "#ECE5F0" },
};

const ModelTypeTag = ({ type, card }: { type?: string; card?: boolean }) => {
	if (!type) {
		return <></>;
	}

	return (
		<Box
			ml={card ? 3 : 0}
			position={"relative"}
			top={card ? "-16px" : "0"}
			style={{
				display: "inline-block",
				borderRadius: "4px",
				padding: "2px 6px",
				backgroundColor: modelTagColor[type as ModelTagEnum]?.backgroundColor,
			}}
		>
			<Typography
				style={{
					textTransform: "uppercase",
					color: modelTagColor[type as ModelTagEnum]?.color,
					fontSize: "12px",

					fontWeight: 700,
				}}
			>
				{type}
			</Typography>
		</Box>
	);
};

export default ModelTypeTag;
